import 'apps/pathways/styles/components/sections/readiness.scss';
import React from 'react';
import PropTypes from 'prop-types';
import ReadinessBreakpoint from 'apps/pathways/components/readiness-breakpoints';
import SoftSkillsSVG from 'apps/pathways/icons/readiness_soft_skills.svg';
import HardSkillsSVG from 'apps/pathways/icons/readiness_hard_skills.svg';
import EducationSVG from 'apps/pathways/icons/readiness_education.svg';

class ReadinessCategory extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    readiness: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.string
  }

  determineIcon = () => {
    switch(this.props.name) {
      case 'soft skills':
        return SoftSkillsSVG
      case 'hard skills':
        return HardSkillsSVG
      case 'education':
        return EducationSVG
      default:
        return SoftSkillsSVG
    }
  }

  readinessColor = () => {
    const score = this.props.readiness;
    return ReadinessBreakpoint(score);
  }

  render() {
    const ReadinessIcon = this.determineIcon();

    return(
      <div className={'readiness-section-category ' + this.props.active} onClick={this.props.onClick}>
        <div className={'readiness-icon-swoosh ' + this.readinessColor() }>
          <ReadinessIcon className={'readiness-icon ' + this.props.name} height='150' width='150' />
        </div>
        <h3>{this.props.name}</h3>
      </div>
    )
  }

}

export default ReadinessCategory;
